module.exports = __webpack_public_path__ + "img/2016-05.1a0b0c50.jpg";